module.exports = __webpack_public_path__ + "static/media/CTLI_15-235w.fc6cccf0.jpg";